/*
 * STL GWP cart sync — re-render the cart when Rebuy changes it.
 *
 * Why this exists: Rebuy's GWP widget (308703) adds/removes the free gift on its own,
 * ~1s AFTER the theme's cart request has already rendered the drawer / cart page.
 * Nothing in the theme hears about that change, so the cart kept showing the old lines
 * (gift missing or lingering, stale progress bar, no empty state) until a reload.
 * Verified with Playwright on the preview theme, 2026-09-14.
 *
 * Rebuy fires `rebuy:cart.change` on document after every cart change (its own and the
 * theme's). Each rendered cart carries its line keys in [data-stl-cart-keys]; when
 * /cart.js no longer matches, re-render the same sections the theme's own cart code
 * renders (CartItems#getSectionsToRender). Deliberately does NOT publish cartUpdate:
 * CartItems#onCartUpdate only swaps part of the drawer and never sets the empty state.
 */
(function () {
  if (window.__stlGwpInit) return;
  window.__stlGwpInit = true;

  var tId = null;
  var running = false;
  var pending = false;

  function containers() {
    return Array.prototype.slice.call(document.querySelectorAll('cart-items, cart-drawer-items')).filter(function (el) {
      return typeof el.getSectionsToRender === 'function';
    });
  }

  function isStale(cart) {
    var keys = cart.items.map(function (item) { return item.key + ','; }).join('');
    var markers = document.querySelectorAll('[data-stl-cart-keys]');
    for (var i = 0; i < markers.length; i++) {
      if (markers[i].getAttribute('data-stl-cart-keys') !== keys) return true;
    }
    return false;
  }

  function render(cart, sections) {
    var empty = cart.item_count === 0;
    ['cart-drawer', '.cart-order', '#main-cart-footer'].forEach(function (selector) {
      var node = document.querySelector(selector);
      if (node) node.classList.toggle('is-empty', empty);
    });
    containers().forEach(function (el) {
      el.classList.toggle('is-empty', empty);
      el.getSectionsToRender().forEach(function (section) {
        var container = document.getElementById(section.id);
        var html = sections[section.section];
        if (!container || !html) return;
        var source = new DOMParser().parseFromString(html, 'text/html').querySelector(section.selector);
        // e.g. #main-cart-shipping is not rendered at all once the cart is empty.
        if (!source) return;
        (container.querySelector(section.selector) || container).innerHTML = source.innerHTML;
      });
    });
  }

  function sync() {
    if (running) {
      pending = true;
      return;
    }
    running = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        if (!isStale(cart)) return;
        var names = [];
        containers().forEach(function (el) {
          el.getSectionsToRender().forEach(function (section) {
            if (names.indexOf(section.section) === -1) names.push(section.section);
          });
        });
        if (!names.length) return;
        return fetch(window.location.pathname + '?sections=' + names.join(','))
          .then(function (response) { return response.json(); })
          .then(function (sections) { render(cart, sections); });
      })
      .catch(function (e) {
        console.warn('[stl-gwp] cart sync failed', e);
      })
      .then(function () {
        running = false;
        if (pending) {
          pending = false;
          sync();
        }
      });
  }

  document.addEventListener('rebuy:cart.change', function () {
    clearTimeout(tId);
    tId = setTimeout(sync, 300);
  });
})();
